import { CreditCardRewardsType } from '../CreditCardRewardsTypes';

const CreditCardRewardsTypeFormatted: Partial<
  Record<CreditCardRewardsType, string>
> = {
  [CreditCardRewardsType.CASH_BACK]: 'Cash back',
  [CreditCardRewardsType.CHASE_ULTIMATE_REWARDS]:
    'Chase Ultimate Rewards points',
  [CreditCardRewardsType.AMERICAN_EXPRESS_MEMBERSHIP_REWARDS]:
    'American Express Membership Rewards points',
  [CreditCardRewardsType.CITI_THANKYOU_POINTS]: 'Citi ThankYou points',
  [CreditCardRewardsType.CAPITAL_ONE_REWARDS]: 'Capital One points',
  [CreditCardRewardsType.BILT_REWARDS]: 'Bilt Rewards points',
  [CreditCardRewardsType.WELLS_FARGO_REWARDS]: 'Wells Fargo points',
  [CreditCardRewardsType.BANK_OF_AMERICA_REWARDS]: 'Bank of America points',
  [CreditCardRewardsType.BARCLAYCARD_REWARDS]: 'Barclaycard points',
  [CreditCardRewardsType.RCI_REWARDS]: 'RCI Member Rewards points',
  [CreditCardRewardsType.BREX]: 'Brex points',
  [CreditCardRewardsType.US_BANK_REWARDS]: 'US Bank points',
  [CreditCardRewardsType.MARRIOTT_BONVOY]: 'Marriott Bonvoy points',
  [CreditCardRewardsType.HILTON]: 'Hilton Honors points',
  [CreditCardRewardsType.UNITED]: 'United miles',
  [CreditCardRewardsType.ALASKA]: 'Alaska Airlines miles',
  [CreditCardRewardsType.AMERICAN]: 'American Airlines miles',
  [CreditCardRewardsType.AVIOS]: 'Avios',
  [CreditCardRewardsType.SOUTHWEST]: 'Southwest miles',
  [CreditCardRewardsType.JETBLUE]: 'TrueBlue points',
  [CreditCardRewardsType.HAWAIIAN]: 'Hawaiian miles',
  [CreditCardRewardsType.EMIRATES]: 'Emirates Skywards miles',
  [CreditCardRewardsType.FRONTIER]: 'Frontier miles',
  [CreditCardRewardsType.SPIRIT_AIRLINES]: 'Spirit miles',
  [CreditCardRewardsType.DELTA]: 'Delta SkyMiles',
  [CreditCardRewardsType.AIR_FRANCE_KLM_FLYING_BLUE]:
    'Air France-KLM Flying Blue miles',
  [CreditCardRewardsType.AIR_CANADA_AEROPLAN]: 'Air Canada Aeroplan miles',
  [CreditCardRewardsType.LUFTHANSA]: 'Lufthansa miles',
  // [CreditCardRewardsType.BEST_WESTERN]: "Best Western points",
  [CreditCardRewardsType.CHOICE]: 'Choice Privileges points',
  [CreditCardRewardsType.HYATT]: 'World of Hyatt points',
  [CreditCardRewardsType.IHG]: 'IHG points',
  [CreditCardRewardsType.WYNDHAM]: 'Wyndham points',
  [CreditCardRewardsType.DISNEY_REWARDS_DOLLARS]: 'Disney Rewards dollars',
  [CreditCardRewardsType.CARNIVAL]: 'Carnival FunPoints',
  [CreditCardRewardsType.NORWEGIAN_CRUISE_POINTS]: 'Norwegian Cruise points',
  [CreditCardRewardsType.MYCRUISE_POINTS]: 'MyCruise points',
  [CreditCardRewardsType.BREEZEPOINTS]: 'Breeze points',
  [CreditCardRewardsType.ALLWAYS_POINTS]: 'Allegiant Allways Points',
  [CreditCardRewardsType.EXPEDIA]: 'Expedia points',
  [CreditCardRewardsType.GM_REWARDS_POINTS]: 'GM Rewards points',
  [CreditCardRewardsType.GM_BUSINESS_CARD_POINTS]: 'GM Business Card points',
  [CreditCardRewardsType.GAME_PASS_ULTIMATE]: 'Xbox Game Pass Ultimate',
  [CreditCardRewardsType.GIFT_CARD]: 'Gift card',
};

export const formatRewardsType = (value: CreditCardRewardsType) => {
  return CreditCardRewardsTypeFormatted[value] ?? value;
};
